import { createStore } from 'vuex';
import api from '@/services/api';
import textService from '@/services/textService'
import { useToast } from 'vue-toastification'; // ایمپورت Toast
const toast = useToast();
import CryptoJS from 'crypto-js'; // وارد کردن کتابخانه
import { isDarkColor } from '@/utils/colorUtils';
import { loadTheme } from '@/themes/index';


async function generateUniqueId() {
  const parsedUrl = new URL(window.location.href); // پارس کردن URL
  const baseUrl = `${parsedUrl.protocol}//${parsedUrl.host}${parsedUrl.pathname}`; // ترکیب پروتکل، هاست و مسیر
  const hashHex = CryptoJS.SHA256(baseUrl).toString(CryptoJS.enc.Hex); // تولید هش و تبدیل به رشته هگزادسیمال
  return hashHex; // بازگشت شناسه یکتا
}

const store = createStore({
  state: {

    additionalInfo: "",
    activePage:"splash",

    // theme
    // مقادیر: 'default' | 'dark' | 'light'
    // default = همون رنگ بکند، dark/light = استاندارد vuetify
    currentTheme: null,
    themeMode: 'default',
    defaultIsDark: false,
    primaryColor: '#1976D2', // رنگ اصلی از بکند

    baseLoading: false,
    loginDialogStatus: false,
    
    info: {
      direct_title: "سیستم رزرواسیون لیمو",
      gateway:"Offline",
    },
    serviceName: {},
    baseUrl: 'https://limoapp.ir',
    fileBaseUrl: 'https://limoapp.ir',
    node_uid: '',
    authTokenKey: '', // کلید برای authToken
    authToken: '', // توکن
    mobile: '',
    // booking
    service: {},
    serviceEmployees: [],
    bookingSelectEmployeDialogStatus: false,
    bookingSelectServiceDialogStatus: false,
    employe: {},
    employeDays: [],
    employeDaysServices: {},
    employeServicePrice: {},
    bookingDialogStatus: false,
    day: {},
    bookingLoading: false,
    availableTimes: [],
    time: "",
    acceptRules: false,
    rulesDialogStatus: false,
    
    
    // برای قسمت پروفایل کاربر
    user:{
      entry:"",
      mobile_field:"",
    },
    showProfileDialogStatus: false,

    // برای قسمت فرم خدمات و اطلاعات خودرو یا مریض
    bookingSelectInfoDialogStatus: false,
    entries:[],
    editing_entry:{},
    info_entry_id:{},

    // برای لیست سفارشات و رزرو ها
    orders:[],

    // بلاگ
    blog: {
      loading: false,
      posts: [],
      categories: [],
      page: 1,
      lastPage: 1,
      total: 0,
    },
    blogPost: {
      loading: false,
      post: null,
      category: null,
      related: [],
    },
  },
  mutations: {
    setActivePage(state, page) {
      state.activePage = page;
    },

    setTheme(state, themeModule) {
      state.currentTheme = themeModule;
    },

    setThemeMode(state, mode) {
      state.themeMode = mode;
      localStorage.setItem('themeMode', mode);
      const vuetify = window.__vuetify;
      if (!vuetify?.theme) return;
      const map = { default: 'userDefault', light: 'light', dark: 'dark' };
      vuetify.theme.global.name.value = map[mode] ?? 'userDefault';
    },

    
    setFormInfo(state, info) {
      state.info = Object.assign(state.info, info);
      state.mobile = info.mobile;
      if (!!state.info.serives && state.info.serives.length > 0) {
        state.serviceName = state.info.serives.reduce((acc, item) => {
          acc[item.id] = item.title;
          return acc;
        }, {})
      }
    },
   
    setNodeUid(state, node_uid) {
      state.node_uid = node_uid;
    },
    setLoginDialogStatus(state, status) {
      state.loginDialogStatus = status;
    },
    setAuthToken(state, token) {
      localStorage.setItem(state.authTokenKey, token); // استفاده از کلید هش
      state.authToken = token;
    },
    setMobile(state, mobile) {
      state.mobile = mobile;
    },
    logout(state) {
      if(confirm("آیا مطمئنید؟")){
        state.authToken = '';
        localStorage.removeItem(state.authTokenKey); // حذف توکن با کلید هش
        state.activePage = "splash";
      }
    },
    setService(state, service) {
      state.availableTimes = [];
      state.service = service;
      state.serviceEmployees = state.info.employees.filter(e => (!!e.options && !!e.options.services && e.options.services.map(s => s.id).includes(service.id)));
      state.day = {};
      state.availableTimes = [];
      state.time = "";
    },
    setBookingSelectEmployeDialogStatus(state, status) {
      state.bookingSelectEmployeDialogStatus = status;
    },
    setBookingSelectInfoDialogStatus(state, status) {
      state.bookingSelectInfoDialogStatus = status;
    },
    setBookingSelectServiceDialogStatus(state, status) {
      state.bookingSelectServiceDialogStatus = status;
    },
    setEmploye(state, employe) {
      state.employe = employe;
      if (!!employe.options && !!employe.options.days) {
        state.employeDays = employe.options.days.map(d => d.id);
        employe.options.days.forEach(item => {
          state.employeDaysServices[item.id] = item.services;
        });
        employe.options.services.forEach(item => {
          state.employeServicePrice[item.id] = item.price;
        });
      } else {
        state.employeDays = [];
        state.employeDaysServices = {};
      }
    },
    setBookingDialogStatus(state, status) {
      if (status == false) {
        state.service = {};
        state.serviceEmployees = [];
        state.employe = {};
        state.employeDays = [];
        state.employeDaysServices = {};
        state.employeServicePrice = {};
      }
      state.acceptRules = false;
      state.bookingDialogStatus = status;
    },
    setAcceptRules(state, status) {
      state.acceptRules = status;
    },
    setRulesDialogStatus(state, status) {
      state.rulesDialogStatus = status;
    },
    setBookingSelectedInfo(state, data) {
      state.info_entry_id = data;
    },
    setSelectedDay(state, day) {
      state.day = day;
    },
    setBookingLoading(state, status) {
      state.bookingLoading = status;
    },
    setAvailableTimes(state, times) {
      state.availableTimes = times;
    },
    setSelectedTime(state, time) {
      state.time = time;
    },

    changeFavicon(state) {
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.remove(); // حذف favicon قبلی
      }
      if (state.info.form_icon && state.info.form_icon.length > 5) {
        var url = state.fileBaseUrl + state.info.form_icon;
        link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = url;
        document.head.appendChild(link);
      }
    },
    loadScript(state,scriptText) {
      // ایجاد یک div موقت برای قرار دادن HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = scriptText;
      document.body.appendChild(tempDiv);

      // پیدا کردن و اجرای اسکریپت‌های داخل HTML
      tempDiv.querySelectorAll("script").forEach((scriptTag) => {
        if (scriptTag.src) {
          // اگر اسکریپت src داشته باشد، آن را مجدد لود می‌کنیم
          const newScript = document.createElement("script");
          newScript.src = scriptTag.src;
          newScript.async = true;
          document.body.appendChild(newScript);
        } else {
          // اگر اسکریپت inline باشد، کد آن را اجرا می‌کنیم
          const inlineScript = document.createElement("script");
          inlineScript.textContent = scriptTag.textContent;
          document.body.appendChild(inlineScript);
        }
      });
      const children = tempDiv.children;
      for (let child of children) {
        if (child.tagName !== 'SCRIPT' && child.tagName !== 'LINK' && child.tagName !== 'META' && child.tagName !== 'TITLE' && child.tagName !== 'BASE') {
          state.additionalInfo += child.outerHTML
        }
      }
      document.body.removeChild(tempDiv);
    },



    // برای قسمت پروفایل کاربر
    setUserInfo(state,info){
      state.user = Object.assign(state.user, info);
      state.showProfileDialogStatus=!!info.openModal;
    },

    // بلاگ
    setBlogLoading(state, status) {
      state.blog.loading = status;
    },
    setBlogList(state, data) {
      state.blog.posts = data.posts || [];
      state.blog.categories = data.categories || [];
      state.blog.page = data.page || 1;
      state.blog.lastPage = data.lastPage || 1;
      state.blog.total = data.total || 0;
    },
    setBlogPostLoading(state, status) {
      state.blogPost.loading = status;
    },
    setBlogPostData(state, data) {
      state.blogPost.post = data.post || null;
      state.blogPost.category = data.category || null;
      state.blogPost.related = data.related || [];
    },
  },
  actions: {
    async GetOrders({ commit, state }) {
      if (state.authToken == '') {
        toast.error('برای مشاهده سفارشات باید ابتدا وارد پنل خود شوید!');
        setTimeout(() => {
          commit('setLoginDialogStatus', true);
        }, 2000);
        return;
      }
      
      commit('setBookingLoading', true);
      try {
        const response = await api.get('/booking/order/list?id='+state.info.form_id);
        if (response.data.success) {
          state.orders = response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },

    async fetchBaseData({ commit, state }) {
      state.baseLoading = true;
      try {
        const response = await api.get('/booking/base');
        if (response.data.success) {
          commit('setUserInfo',{
              entry:response.data.data.entry,
              mobile_field:response.data.data.mobile_field
          });
          commit('setFormInfo', response.data.data);
          commit('setNodeUid', response.data.data.node_uid);
          commit('changeFavicon'); // ✅ تغییر Favicon بعد از دریافت داده
          if(!!response.data.data.form_scripts && response.data.data.form_scripts.length > 20) {
            commit('loadScript', response.data.data.form_scripts);
          }
          if(!!response.data.data.lang_keyword && response.data.data.lang_keyword.length > 5) {
            textService.updateTexts(JSON.parse(response.data.data.lang_keyword));
          }

          // لود تم از form_shop_theme
          const themeName = response.data.data.theme ?? 'default';
          const themeModule = await loadTheme(themeName);
          commit('setTheme', themeModule);

          const primaryColor = response.data.data.theme_color ?? '#1976D2';
          state.primaryColor = primaryColor;
          const vuetify = window.__vuetify;
          if (vuetify?.theme) {
            const isColorDark = isDarkColor(primaryColor);
            // userDefault: رنگ کاربر + dark/light بر اساس luminance
            vuetify.theme.themes.value.userDefault.colors.primary = primaryColor;
            vuetify.theme.themes.value.userDefault.dark = isColorDark;
            // light و dark: primary همون رنگ کاربر، بقیه رنگ‌ها استاندارد vuetify
            vuetify.theme.themes.value.light.colors.primary = primaryColor;
            vuetify.theme.themes.value.dark.colors.primary  = primaryColor;
            if (themeModule.vuetifyOverrides?.defaults) {
              vuetify.defaults.value = { ...vuetify.defaults.value, ...themeModule.vuetifyOverrides.defaults };
            }
          }

          state.defaultIsDark = isDarkColor(primaryColor);
          const savedMode = localStorage.getItem('themeMode') ?? 'default';
          commit('setThemeMode', savedMode);
        }
      } catch (error) {
        console.error(error);
      }
      state.baseLoading = false;
    },

    changeFavicon(){
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.remove(); // حذف favicon قبلی
      }
      if(!!this.info.form_icon && this.info.form_icon.length > 5){
        var url = this.fileBaseUrl+this.info.form_icon
        // ایجاد favicon جدید
        link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = url;
        document.head.appendChild(link);
      }
    },

    logout({ commit }) {
      commit('logout');
    },
    async checkHoursOfEmploye({ commit, state }, day) {
      if (!!state.day && !!state.day.date && state.day.date == day.date) {
        return;
      }
      commit('setSelectedDay', day);
      commit('setBookingLoading', true);
      try {
        const response = await api.post('/booking/check/hours', {
          day: state.day,
          employe_id: state.employe.id,
          service_id: state.service.id,
          id: state.info.form_id
        });
        if (response.data.success) {
          commit('setAvailableTimes', response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    selectBookingTime({ commit }, slot) {
      if (slot.booked) {
        toast.error('این ساعت قبلا رزرو شده است! لطفا زمان دیگری انتخاب کنید.');
        return;
      }
      commit('setSelectedTime', slot.time);
    },
    async SubmitOrder({ commit, state }) {
      if (state.authToken == '') {
        toast.error('برای رزرو باید ابتدا وارد پنل خود شوید!');
        setTimeout(() => {
          commit('setLoginDialogStatus', true);
        }, 2000);
        return;
      }
      if (!state.day || !state.day.date) {
        toast.error('روز به درستی انتخاب نشده است!');
        return;
      }
      if (state.time == "" || state.time == undefined) {
        toast.error('ساعت به درستی انتخاب نشده است!');
        return;
      }
      if (!!state.info.booking_rules && state.info.booking_rules.length > 0 && !state.acceptRules) {
        toast.error('برای رزرو باید قوانین سایت را بپذیرید!');
        return;
      }
      commit('setBookingLoading', true);
      try {
        const response = await api.post('/booking/order/submit', {
          day: state.day,
          employe_id: state.employe.id,
          employe_variable: state.employe.variable??{},
          service_id: state.service.id,
          id: state.info.form_id,
          time: state.time,
          info_entry_id: (!!state.info_entry_id && !!state.info_entry_id.id)?state.info_entry_id.id:null,
          info_form_id: (!!state.info.info_form && !!state.info.info_form.form_id)?state.info.info_form.form_id:null,
        });
        if (response.data.success) {
          if (!!response.data.data && !!response.data.data.length > 0) {
            setTimeout(() => {
              window.location.href = response.data.data;
            }, 1000);
          }
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    async setAuthToken({ commit }, token) {
      const uniqueId = await generateUniqueId(); // تولید کلید یکتا
      commit('setAuthToken', token);
      commit('setAuthTokenKey', uniqueId); // ذخیره کلید یکتا
    },
    async fetchAuthToken({ state }) {
      state.authTokenKey = await generateUniqueId(); // تولید کلید یکتا
      state.authToken = localStorage.getItem(state.authTokenKey) || ''; // بازیابی توکن با کلید یکتا
    },

    // بلاگ
    async fetchBlogList({ commit, state }, { category = null, page = 1 } = {}) {
      commit('setBlogLoading', true);
      try {
        const params = { page };
        if (state.info.form_id) params.id = state.info.form_id;
        if (category) params.category = category;
        const response = await api.get('/forms/form/blog/base', { params });
        if (response.data.success) {
          commit('setBlogList', response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBlogLoading', false);
    },
    async fetchBlogPost({ commit, state }, slug) {
      commit('setBlogPostLoading', true);
      try {
        const params = { slug };
        if (state.info.form_id) params.id = state.info.form_id;
        const response = await api.get('forms/form/blog/post', { params });
        if (response.data.success) {
          commit('setBlogPostData', response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBlogPostLoading', false);
    },
  },
  getters: {
    getCounter(state) {
      return state.counter;
    },
    getBaseUrl: (state) => state.baseUrl,
    getNodeUid: (state) => state.node_uid,
    getAuthToken: (state) => state.authToken,
    // دسترسی به بلاگ - بر اساس فیلدی که بکند توی ریکوئست /booking/base برمی‌گردونه
    hasBlogAccess: (state) => !!state.info.blog_enabled,
    getOfferPrice(state) {
      if (!!state.service && !!state.employeServicePrice[state.service.id]) {
        return state.employeServicePrice[state.service.id];
      }
      return 0;
    },
    getDaysFilterByEmployeAndService(state) {
      if (!!state.info.days && state.info.days.length > 0) {
        if (!!state.employeDays && state.employeDays.length > 0) {
          if (!!state.employeDaysServices && Object.keys(state.employeDaysServices).length > 0) {
            return state.info.days
              .filter(d =>
                (
                  state.employeDays.includes(d.numOffWeek) &&
                  !!state.employeDaysServices[d.numOffWeek] &&
                  state.employeDaysServices[d.numOffWeek].includes(state.service.id)
                )
              );
          }
        }
      }
      return [];
    },
  },
});

export default store;
